import {KnowledgeSectionFieldsFragment, OfferingPageFieldsFragment} from '../../../../__generated__/datocms.types'
import {OfferingPage, OfferingPageContent} from '../types/offering-page.types'
import {validateDatoCmsTypes} from './common.serde'
import {parseReviewSection} from './review-section.serde'
import {parseSupportSection} from './support-section.serde'
import {parseKnowledgeSection} from './knowledge-section.serde'
import {parsePresentationSection} from './presentation-section.serde'
import {parsePageMeta} from './seo.serde'
import {LinkService} from '../../i18n/link.service'
import {parseSignupSection} from './signup-section.serde'
import {parseContentSection} from './content-section.serde'
import {parseRelatedOfferingsSection} from './related-offerings-section.serde'
import {parseVideoSection} from './video-section.serde'

export function parseOfferingPage(
  linkService: LinkService,
  e: OfferingPageFieldsFragment,
  offeringKnowledgeSection?: KnowledgeSectionFieldsFragment,
): OfferingPage {
  const entry = validateDatoCmsTypes(e)
  const page = validateDatoCmsTypes(entry)
  const content: OfferingPageContent[] = page.content
    .map((c): OfferingPageContent | undefined => {
      switch (c?.__typename) {
        case 'ReviewSectionModelRecord':
          return parseReviewSection(c)
        case 'SupportSectionModelRecord':
          return parseSupportSection(c)
        case 'FieldProDirectorySectionModelRecord':
          return {__type: 'ProDirectory'}
        case 'KnowledgeSectionModelRecord': {
          //offering specific
          if (offeringKnowledgeSection) {
            return parseKnowledgeSection(offeringKnowledgeSection)
          }
          //default
          return parseKnowledgeSection(c)
        }
        case 'PresentationSectionModelRecord':
          return parsePresentationSection(c)
        case 'FieldSignupSectionRecord':
          return parseSignupSection(c)
        case 'FieldContentSectionModelRecord':
          return parseContentSection(c)
        case 'FieldRelatedOfferingsSectionRecord':
          return parseRelatedOfferingsSection(c)
        case 'VideoSectionRecord':
          return parseVideoSection(c)
        default: {
          return undefined
        }
      }
    })
    .filter((c): c is OfferingPageContent => !!c)

  return {
    content: content || [],
    cover: {
      title: entry.coverTitle,
      subtitle: entry.coverSubtitle,
      isSellingPointBarShown: entry.displayCoverSellingPointBar,
    },
    seo: parsePageMeta(linkService, entry.seo, entry._locales),
  }
}
